module.exports = __webpack_public_path__ + "src/assets/textures/env/barrel/barrel_512_bake.png";